import api from '../api';

const controller = 'crfDefinicaoProjeto';

export interface CrfProjetoDefinicao {
    id: string;
    index: number;
    codigo: string;
    numero: string;
    nome: string;
    previsao: string;
    forecastAno: boolean;
    contagemNaoPrevisto: boolean;
    vrp: boolean;
    rpp: boolean;

    previsaoCodigo: number;
    crfCicloOrcamentarioId: string;
    statusProjetoNome: string;
    dataConclusao: string;
}

export const getAllCrfProjetoDefinicao = (ano: number) =>
    api.get<CrfProjetoDefinicao[]>(`${controller}/${ano}`);

export const updateCrfCicloOrcamentarioProjeto = (values: CrfProjetoDefinicao) =>
    api.put<CrfProjetoDefinicao>(`${controller}/updateCrfDefinicaoProjeto/${values.id}`, values);

export const updateConcluirCrfCicloOrcamentario = (id: string) =>
    api.put<CrfProjetoDefinicao>(`${controller}/concluirCrfCicloOrcamentario/${id}`);

